import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { ListViewModule } from '@y42/core/list-view';
import { RefreshJobsButtonModule } from '@y42/job/refresh-jobs-button';
import { DataTestColumnsCellRendererModule } from '../cell-renderers/data-test-columns-cell-renderer/data-test-columns-cell-renderer.module';
import { DataTestConditionCellRendererModule } from '../cell-renderers/data-test-condition-cell-renderer/data-test-condition-cell-renderer.module';
import { DataTestImportTypeCellRendererModule } from '../cell-renderers/data-test-import-type-cell-renderer/data-test-import-type-cell-renderer.module';
import { DataTestTypeCellRendererModule } from '../cell-renderers/data-test-type-cell-renderer/data-test-type-cell-renderer.module';
import { DataTestJobOverviewListComponent } from './data-test-job-overview-list.component';

@NgModule({
  declarations: [DataTestJobOverviewListComponent],
  exports: [DataTestJobOverviewListComponent],
  imports: [
    CommonModule,
    ListViewModule,
    DataTestTypeCellRendererModule,
    DataTestImportTypeCellRendererModule,
    DataTestConditionCellRendererModule,
    DataTestColumnsCellRendererModule,
    RefreshJobsButtonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
  ],
})
export class DataTestJobOverviewListModule {}
